// Category constants — single source of truth for category metadata
export const DEFAULT_META = { label: 'Other', icon: 'more', color: '#6b7280' };
